// src/components/Navbar.jsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const items = [
  { to: "/",         label: "Home",    id: "home" },
  { to: "/about",    label: "About Me",   id: "About"},
  { to: "/projects", label: "Projects",id: "projects" },
  { to: "/resume",   label: "Resume",  id: "resume" },
  { to: "/contact",  label: "Contact", id: "contact" },
  
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const orig = document.body.style.overflow;
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = orig);
  }, [open]);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const navH = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--nav-h") || "72",
      10
    );
    const rect = el.getBoundingClientRect();
    const top = window.scrollY + rect.top - navH;
    window.scrollTo({ top, behavior: "smooth" });
  };

  const handleNav = (to, id) => {
    setOpen(false);
    if (pathname === to) {
      scrollToId(id);
    } else {
      navigate(to);
    }
  };

  return (
    <>
      <nav
        style={{
          position: "sticky",
          top: 0,
          zIndex: 30,
          background: "#121212",
          color: "#fff",
          padding: "0.8rem 5%",
          display: "grid",
          gridTemplateColumns: "40px 1fr 40px",
          alignItems: "center",
          boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
        }}
      >
        <button
          onClick={() => setOpen(v => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          style={{ background: "none", border: 0, cursor: "pointer" }}
        >
          <div style={{ width: 28, height: 3, background: "#fff", margin: "4px 0" }} />
          <div style={{ width: 28, height: 3, background: "#fff", margin: "4px 0" }} />
          <div style={{ width: 28, height: 3, background: "#fff", margin: "4px 0" }} />
        </button>

        <div
          style={{
            textAlign: "center",
            pointerEvents: "none",
            fontWeight: "bold",
            fontSize: "1.6rem",
          }}
        >
          CHRISTIAN LIRA GO.
        </div>

        <div />
      </nav>

      {open && (
        <>
          <div
            onClick={() => setOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              zIndex: 20,
            }}
          />
          <aside
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 21,
              width: "80%",
              maxWidth: 300,
              height: "100vh",
              background: "#1e1e1e",
              color: "#fff",
              padding: "2rem 1.25rem",
              transform: "translateX(0)",
              transition: "transform 0.3s ease",
              boxShadow: "2px 0 8px rgba(0,0,0,0.3)",
            }}
          >
            <button
              onClick={() => setOpen(false)}
              aria-label="Close menu"
              style={{
                background: "none",
                border: 0,
                color: "#fff",
                fontSize: "1.4rem",
                float: "right",
                cursor: "pointer",
              }}
            >
              ✕
            </button>

            <nav style={{ marginTop: "4rem", display: "grid", gap: "1rem" }}>
              {items.map(({ to, label, id }) => (
                <button
                  key={to}
                  onClick={() => handleNav(to, id)}
                  className={`nav-link ${pathname === to ? "active" : ""}`}
                >
                  {label}
                </button>
              ))}
            </nav>
          </aside>
        </>
      )}

      <style>{`
        :root { --nav-h: 72px; }

        .nav-link {
          text-align: left;
          background: none;
          border: 0;
          color: #fff;
          font-size: 1.1rem;
          cursor: pointer;
          transition: color 0.3s ease, transform 0.2s ease, background 0.3s ease;
          padding: 0.4rem 0.2rem;
          border-radius: 4px;
        }
        .nav-link:hover {
          color: #61dafb;
          background: rgba(97, 218, 251, 0.15);
          transform: translateX(4px);
        }
        .nav-link:active {
          color: #00bcd4;
        }
        .nav-link.active {
          color: #61dafb;
          font-weight: bold;
        }
      `}</style>
    </>
  );
}



